module.exports = __webpack_public_path__ + "img/arrow.c271234e.svg";